import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { WayPurchaseSelectionCardVm } from '../../models/way-purchase.models';
import {
  WAY_PURCHASE_PLATE_PLACEHOLDER,
  WAY_PURCHASE_PLATE_REQUIRED_MESSAGE,
} from '../../utils/way-purchase-plate.util';

@Component({
  selector: 'app-way-purchase-selection-card',
  standalone: true,
  imports: [CommonModule, FormsModule, MatInputModule],
  templateUrl: './way-purchase-selection-card.component.html',
  styleUrls: ['./way-purchase-selection-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WayPurchaseSelectionCardComponent {
  @Input({ required: true }) card!: WayPurchaseSelectionCardVm;
  @Input() cardPlateInputs: Record<string, string> = {};
  @Input() plateInputDisabled = false;
  @Input() cardError = '';
  @Input() showActions = true;
  @Input() isBusy = false;
  @Input() isCardBusy = false;

  @Output() use = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() plateInputChange = new EventEmitter<string>();

  readonly platePlaceholder = WAY_PURCHASE_PLATE_PLACEHOLDER;

  plateInputId(): string {
    return `way-card-plate-${this.card.id}`;
  }

  plateInputErrorId(): string {
    return `${this.plateInputId()}-error`;
  }

  onCardPlateInput(value: string): void {
    this.plateInputChange.emit(value);
  }

  plateInputError(): string {
    const error = this.cardError;
    return this.card.showPlateInput && error === WAY_PURCHASE_PLATE_REQUIRED_MESSAGE ? error : '';
  }

  cardActionError(): string {
    const error = this.cardError;
    if (!error || this.plateInputError()) {
      return '';
    }
    return error;
  }

  isUseDisabled(): boolean {
    return !this.card.canUse || this.isBusy;
  }

  onUse(): void {
    if (this.isUseDisabled()) {
      return;
    }
    this.use.emit();
  }

  onCancel(): void {
    if (!this.card.canCancel || this.isBusy || this.card.option.source !== 'shop') {
      return;
    }
    this.cancel.emit();
  }
}
